import { Button, Empty } from '@hb/coffee';
import Component from 'vue-class-component';

import orderV2 from '@/api/ordersV2';
import TabBar from '@/components/apply-tabs/index.vue';
import { ApprovalStatus } from '@/enums/preorder';
import { PreApplyItem } from '@/po/PreApplyItem';
import { RouterV2Enum } from '@/router/router-names';
import { ubtPageButton } from '@/shared/utils/ubt';
import RouterHelper from '@/shared/utils/routerHelper';
import { session } from '@/shared/utils/storage';

import { Vue } from 'vue-property-decorator';
import { agreementService } from '@/service/confirm-agreements';
import style from './index.module.scss';

@Component({ name: 'MyPreApply' })
export default class MyPreApply extends Vue {
  private tabs = [
    { label: '全部' },
    { label: '审批中' },
    { label: '审批不通过' },
    { label: '审批通过' },
    { label: '额度失效' },
    { label: '冻结' },
  ];

  private ready = false;

  private allItems: PreApplyItem[] = [];

  private selectedIndex = 0;

  private async created() {
    this.allItems = await orderV2.preApplyLists().finally(() => {
      this.ready = true;
    });
  }

  private onSelectedChange(index: number) {
    this.selectedIndex = index;
  }

  private get filtedItem() {
    const index = this.selectedIndex;
    return index === 0
      ? this.allItems.concat()
      : this.allItems.filter(
        (item: PreApplyItem) => this.statusToIndex(item.creditStatus) === index,
      );
  }

  private statusToIndex(status: string): number {
    if (status === ApprovalStatus.SUBMITTING) {
      return 1;
    }
    if (status === ApprovalStatus.SUCCEEDED) {
      return 3;
    }
    if (status === ApprovalStatus.OVERDUE) {
      return 4;
    }
    if (status === ApprovalStatus.FROZEN) {
      return 5;
    }
    return 2;
  }

  private async goProduct(item: PreApplyItem) {
    ubtPageButton(this, '臻有钱_我的额度审批_去提现', '产品', item.productId);
    // 提现前需要触发
    await agreementService.confirmFinanceAgreements();
    if (item.creditStatus === ApprovalStatus.SUCCEEDED) {
      this.$router.push(
        `${RouterV2Enum.applyProduct}?commodityId=${item.productId}`,
      );
    } else {
      session.set('myProfile', true);
      this.$router.push(
        `${RouterV2Enum.applyProduct}?commodityId=${item.productId}`,
      );
    }
  }

  private renderList(items: PreApplyItem[]) {
    return items.length <= 0
      ? this.renderNoItem()
      : items.map((item: PreApplyItem) => (
          <div class={style.item}>
            <div class={style.block}>
              <img class={style.icon} src={item.productIcon} />
              <div class={style.itemRight}>
                <div
                  class={[style.title, this.hasSubTitle(item) && style.title2]}
                >
                  {item.productName}
                </div>

                {(item.creditStatus === ApprovalStatus.SUCCEEDED
                  || item.creditStatus === ApprovalStatus.FROZEN) && (
                  <div class={style.subTitle}>
                    可提现额度：
                    <span class={style.subTitleValue}>
                      {item.availableAmount}
                    </span>
                  </div>
                )}
                {item.creditStatus === ApprovalStatus.OVERDUE && (
                  <div class={style.subTitle}>
                    额度有效期：
                    <span class={style.subTitleValue}>
                      {item.creditExpiryDate}
                    </span>
                  </div>
                )}
              </div>
              {(item.creditStatus === ApprovalStatus.SUCCEEDED
                || item.creditStatus === ApprovalStatus.FROZEN)
                && (item.creditStatus === ApprovalStatus.FROZEN
                  ? !item.enableWithDraw
                  : item.enableWithDraw)
                && !!Number(item.availableAmount) && (
                  <Button
                    class={style.btn}
                    size="small"
                    onclick={() => this.goProduct(item)}
                  >
                    去提现
                  </Button>
              )}
            </div>
            <div class={style.line} />
            <div class={style.itemBar}>
              <div class={style.left}>申请时间：{item.applyDate}</div>
              <div class={style.right}>
                {this.renderStautsTxt(item.creditStatus)}
              </div>
            </div>
          </div>
      ));
  }

  private hasSubTitle(item: PreApplyItem) {
    return (
      item.creditStatus === ApprovalStatus.SUCCEEDED
      || item.creditStatus === ApprovalStatus.OVERDUE
    );
  }

  private renderStautsTxt(status: string) {
    if (status === ApprovalStatus.SUBMITTING) {
      return <span style="color:#FF5600">审批中</span>;
    }
    if (status === ApprovalStatus.SUCCEEDED) {
      return <span style="color:#08BB5C">审批通过</span>;
    }
    if (status === ApprovalStatus.OVERDUE) {
      return <span style="color:#333333">额度失效</span>;
    }
    if (status === ApprovalStatus.FROZEN) {
      return <span style="color:#333333">冻结</span>;
    }
    return <span style="color:#FF0000">审批不通过</span>;
  }

  private renderNoItem() {
    return (
      <Empty
        type="list"
        title="您还没有该状态的申请记录哦～"
        button-text="回到首页"
        onClick={() => {
          RouterHelper.backHome();
        }}
      />
    );
  }

  private render() {
    return (
      this.ready && (<div class={style.MyPreApply}>
        <div class={style.tab}>
          <TabBar
            listDatas={this.tabs}
            activeIndex={this.selectedIndex}
            scrollable={true}
            onSelectedChange={this.onSelectedChange.bind(this)}
          />
        </div>
        <div class={style.myMain}>
          <div class={style.list}>
            {this.renderList(this.filtedItem)}
          </div>
        </div>
      </div>)
    );
  }
}
